import { DateTime } from 'luxon';
import { SortDirection } from '../LettingTable';
export const getFormattedForecastPrice = (price) => price.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
export const numberSorter = (field, dir) => (a, b) => {
    const s1 = a[field] || 0;
    const s2 = b[field] || 0;
    return dir === SortDirection.ASC || dir === SortDirection.DEFAULT
        ? Number(s1) - Number(s2)
        : Number(s2) - Number(s1);
};
export const numberPropSorter = (field, prop, dir) => (a, b) => {
    const s1 = a[field][prop] || 0;
    const s2 = b[field][prop] || 0;
    return dir === SortDirection.ASC || dir === SortDirection.DEFAULT
        ? Number(s1) - Number(s2)
        : Number(s2) - Number(s1);
};
export const dateSorter = (field, prop, dir) => (a, b) => {
    const s1 = DateTime.fromFormat(a[field][prop], 'dd MMM yyyy');
    const s2 = DateTime.fromFormat(b[field][prop], 'dd MMM yyyy');
    return dir === SortDirection.ASC || dir === SortDirection.DEFAULT
        ? s1.toMillis() - s2.toMillis()
        : s2.toMillis() - s1.toMillis();
};
